import React from "react";
import { DataRequestDetail } from "../../../../../common/models";
import { NotifyConsumer } from "./shared/NotifyConsumer";
import { ResolveAppeal } from "./appeal/ResolveAppeal";
import { ValidateAppeal } from "./appeal/ValidateAppeal";

type Props = {
  request: DataRequestDetail;
};

export const AppealSteps: React.FC<Props> = ({ request }) => {
  switch (request.state) {
    case "VALIDATE_APPEAL":
      return <ValidateAppeal />;
    case "RESOLVE_APPEAL":
      return <ResolveAppeal />;
    case "NOTIFY_CONSUMER":
      return <NotifyConsumer />;
  }
  return null;
};
